module.exports = __webpack_public_path__ + "static/billsbot-australia-ba2072fcc621aa6f7ee3cf64f6441364.svg";